import TTimeline from './timeline.vue'
import TTimelineItem from './timeline-item.vue'
TTimeline.Item = TTimelineItem

TTimeline.install = Vue => {
  Vue.component(TTimeline.name, TTimeline)
}

TTimelineItem.install = Vue => {
  Vue.component(TTimelineItem.name, TTimelineItem)
}

export {
  TTimeline,
  TTimelineItem
}



// WEBPACK FOOTER //
// ./src/module/timeline/index.js